export default "__VITE_ASSET__D4KMQMjk__"